import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {
  JumboMedium,
  BodyLarge,
} from '@spaced-out/ui-design-system/lib/components/Text';
import MainLogo from 'src/images/sense-logo-new-white.svg';
import css from 'src/components/authentication/container/container.css';


const BrandingContainer = () => {
  const {t} = useLabelTranslation();
  return (
    <div className={css.productBrandingSideBar}>
      <MainLogo className={css.brandingLogo} />
      <div className={css.productBrandingContainer}>
        <div className={css.productBranding}>
          <JumboMedium color="inversePrimary">
            {t(
              'Kickstart_Your_Referral_Program_Today',
              'Kickstart Your Referral Program Today',
            )}
          </JumboMedium>
          <div className={css.referralPortalBrandImage} />
          <BodyLarge color="inversePrimary" className={css.brandingSubText}>
            {t(
              'Refer_qualified_candidates_and_track_their_journey_through_the_hiring_process',
              'Refer qualified candidates and track their journey through the hiring process',
            )}
          </BodyLarge>
        </div>
      </div>
    </div>
  );
};

export default BrandingContainer;
